import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../selectors';
import ErrorActions from './error';

class HelpActions {
    static types = actionsFromList([
        'CONTACT_MESSAGE_SENT',
        'HELP_SHOW_CONTACT',
        'HELP_SHOW_FAQ',
        'HELP_SHOW_TOUR',
        'HELP_SHOW_ABOUT',
        'RECEIVED_CONTACTS',
        'RECEIVED_FAQS',
        'REQUESTING_CONTACTS',
        'REQUESTING_FAQS',
        'SENDING_CONTACT_MESSAGE',
        'UPDATE_CONTACT_MESSAGE',
        'UPDATE_CONTACT_SUBJECT_INDEX',
    ]);

    static contactSubjects = [
        'Change Request',
        'Site Inquiry',
        'Sales Inquiry',
        'Support Inquiry',
        'General Inquiry',
    ];

    // sync --------------------------------------------------------------------

    static requestingFaqs = () => ({
        type: HelpActions.types.REQUESTING_FAQS,
    });

    static receivedFaqs = (response) => ({
        type: HelpActions.types.RECEIVED_FAQS,
        payload: { response: response.data },
    });

    static requestingContacts = () => ({
        type: HelpActions.types.REQUESTING_CONTACTS,
    });

    static receivedContacts = (response) => ({
        type: HelpActions.types.RECEIVED_CONTACTS,
        payload: { response: response.data },
    });

    static updateContactSubjectIndex = (index) => ({
        type: HelpActions.types.UPDATE_CONTACT_SUBJECT_INDEX,
        payload: { index },
    });

    static updateContactMessage = (message) => ({
        type: HelpActions.types.UPDATE_CONTACT_MESSAGE,
        payload: { message },
    });

    static sendingContactMessage = () => ({
        type: HelpActions.types.SENDING_CONTACT_MESSAGE,
    });

    static contactMessageSent = () => ({
        type: HelpActions.types.CONTACT_MESSAGE_SENT,
    });

    static showFaqTab = () => ({
        type: HelpActions.types.HELP_SHOW_FAQ,
    });

    static showContactTab = () => ({
        type: HelpActions.types.HELP_SHOW_CONTACT,
    });

    static showTourTab = () => ({
        type: HelpActions.types.HELP_SHOW_TOUR,
    });

    static showAboutTab = () => ({
        type: HelpActions.types.HELP_SHOW_ABOUT,
    });

    // async -------------------------------------------------------------------

    static requestFaqs = () => (dispatch, getState) => {
        dispatch(HelpActions.requestingFaqs());

        getState()
            .api.getFaqs()
            .then((response) => dispatch(HelpActions.receivedFaqs(response)))
            .catch(ErrorActions.errorHandler(dispatch));
    };

    static requestContacts = () => (dispatch, getState) => {
        dispatch(HelpActions.requestingContacts());

        getState()
            .api.getContacts()
            .then((response) =>
                dispatch(HelpActions.receivedContacts(response))
            )
            .catch(ErrorActions.errorHandler(dispatch));
    };

    static sendContactMessage = () => (dispatch, getState) => {
        const state = getState();

        dispatch(HelpActions.sendingContactMessage());

        state.api
            .postContactMessage(
                selectors.help.getContactSubject(state),
                selectors.help.getContactMessage(state)
            )
            .then(() => dispatch(HelpActions.contactMessageSent()))
            .catch(ErrorActions.errorHandler(dispatch));
    };
}

export default HelpActions;



// WEBPACK FOOTER //
// ./app/actions/help.js